title: Behandeling|Behandelingen
fields:
  title: Naam
  durationInMinutes: Duur
  price: Prijs
  description: Beschrijving (optioneel)
  preparationTime: Voor- en natijd (optioneel)
  timeMarginInAdvance: Voorbereiding
  timeMarginAfterwards: Opruimen
  maxNumberOfCustomers: Maximaal aantal deelnemers
  preparationDescriptionForCustomer: Voorbereiding (optioneel)
  healthDeclaration: Gezondheidsverklaring (optioneel)
actions:
  addTreatment: Behandeling toevoegen
labels:
  title: Naam
  numberOfPersons: "{count} persoon|{count} personen"
  durationInMinutes: Duur
  price: Prijs
  description: Beschrijving
  pricePerPerson: Prijs per persoon
  preparationTime: Voor- en natijd
  timeMarginInAdvance: "Voorbereiding:"
  timeMarginAfterwards: "Opruimen:"
  maxNumberOfCustomers: Maximaal aantal deelnemers
  timeSuffix: min
  preparationDescriptionForCustomer: Voorbereiding
  healthDeclaration: Gezondheidsverklaring
  generalInformation: Basisinformatie
  instructions: Instructies
messages:
  manageTreatments: Beheer behandelingen en prijzen
  addTreatment: Wat voor behandeling?
  addTreatmentDescription: Kies een type om door te gaan.
  preparationTimeInfo: Extra tijd voor voorbereiden en opruimen. Deze tijd wordt automatisch gereserveerd bij het plannen van afspraken.
  remove: Behandeling verwijderen
  removeInfo: Weet je zeker dat je deze behandeling wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.
  descriptionPlaceholder: Wat krijgt de klant bij deze behandeling?
  individual:
    title: 1-op-1 behandeling
    description: Behandeling voor één klant tegelijk
    dialogTitle: Nieuwe 1-op-1 behandeling
    dialogDescription: Voeg een behandeling toe voor één klant.
  group:
    title: Groepsbehandeling
    description: Bijvoorbeeld een workshop of cursus
    dialogTitle: Nieuwe groepsbehandeling
    dialogDescription: Voeg een behandeling toe voor meerdere deelnemers.
